import React from "react";

export default function PrivacyPolicy() {
  return (
    <div style={{ maxWidth: "800px", margin: "0 auto", padding: "40px 20px", lineHeight: "1.7" }}>
      <h1>Privacy Policy</h1>
      <p><strong>Last Updated:</strong> 3 March 2026</p>

      <p>
        This Privacy Policy explains how <strong>Event Attendees</strong> collects,
        uses, and protects personal information in connection with event registration services.
      </p>

      <h2>1. Information We Collect</h2>
      <p>We may collect the following information when you register for an event:</p>
      <ul>
        <li>Full Name</li>
        <li>Phone Number</li>
      </ul>

      <h2>2. Purpose of Data Collection</h2>
      <p>The information collected is used for:</p>
      <ul>
        <li>Processing event registration</li>
        <li>Managing attendance and seat allocation</li>
        <li>Sending QR code confirmation via WhatsApp</li>
        <li>Providing event-related notifications</li>
      </ul>

      <h2>3. Data Storage and Security</h2>
      <p>
        Personal data is securely stored in our database and protected using
        industry-standard security measures. We do not sell, rent, or trade
        your personal information to third parties.
      </p>

      <h2>4. WhatsApp Communication</h2>
      <p>
        We use the WhatsApp Cloud API to send event-related notifications and
        QR codes. By registering for an event, you consent to receive WhatsApp
        messages related to that event.
      </p>

      <h2>5. Data Retention</h2>
      <p>
        We retain personal information only for as long as necessary for event
        management and administrative purposes.
      </p>

      <h2>6. Your Rights</h2>
      <p>
        You may request access, correction, or deletion of your personal data
        by contacting us using the information below.
      </p>

      <h2>7. Contact Us</h2>
      <p>
        If you have any questions about this Privacy Policy, please contact:
      </p>
      <p>
        Email: ksn.itdiv@gmail.com
      </p>

      <h2>8. User Data Deletion</h2>
        <p>
        If you would like to request deletion of your personal data,
        please send an email to:
        </p>
        <p>
        Email: ksn.itdiv@gmail.com
        </p>
        <p>
        Please include your full name and phone number used during event registration.
        We will process your request within 7 days.
        </p>

      <p style={{ marginTop: "40px", fontSize: "14px", color: "#666" }}>
        This policy may be updated from time to time. Any changes will be
        posted on this page.
      </p>
    </div>
  );
}